import State from 'store/State';
import { selectWidgetInstancesState } from 'widgets/store/selectors';

export const selectPortfolioPlWidgetsState = (state: State) =>
    selectWidgetInstancesState(state).portfolioPl;

export const selectPortfolioPlState = (state: State, widgetKey: string) =>
    selectPortfolioPlWidgetsState(state)[widgetKey];
